<template>
  <div ref="container" class="map-container"></div>
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { CesiumObj } from './CesiumObj'

const container = ref<HTMLDivElement>()
onMounted(async () => {
  if (!container.value) return
  CesiumObj.bindContainer(container.value)
})
</script>
<style lang="scss">
.map-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}
</style>
